var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 14.15V18.4C20.25 19.494 19.463 20.436 18.378 20.58C16.291 20.857 14.162 21 12 21C9.838 21 7.709 20.857 5.622 20.58C4.537 20.436 3.75 19.494 3.75 18.4V14.15M20.25 14.15C20.4875 13.9436 20.6774 13.6883 20.8069 13.4016C20.9364 13.1149 21.0022 12.8036 21 12.489V8.706C21 7.625 20.232 6.691 19.163 6.531C18.0303 6.36142 16.8919 6.23234 15.75 6.144M20.25 14.15C20.056 14.315 19.83 14.445 19.577 14.53C17.1332 15.3408 14.5748 15.7528 12 15.75C9.352 15.75 6.805 15.321 4.423 14.53C4.17626 14.4479 3.94773 14.3189 3.75 14.15M3.75 14.15C3.51255 13.9436 3.32256 13.6883 3.1931 13.4016C3.06364 13.1149 2.99776 12.8036 3 12.489V8.706C3 7.625 3.768 6.691 4.837 6.531C5.9697 6.36142 7.10809 6.23233 8.25 6.144M15.75 6.144V5.25C15.75 4.65326 15.5129 4.08097 15.091 3.65901C14.669 3.23705 14.0967 3 13.5 3H10.5C9.90326 3 9.33097 3.23705 8.90901 3.65901C8.48706 4.08097 8.25 4.65326 8.25 5.25V6.144M15.75 6.144C13.2537 5.95108 10.7463 5.95108 8.25 6.144M12 12.75H12.008V12.758H12V12.75Z",
    stroke: "#525355",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/Projects.084346e3582acaaa82924788412540f1.svg";
export { ForwardRef as ReactComponent };